module.exports = __webpack_public_path__ + "sunsemweb/img/code.09813b57.jpg";